import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { AppViewService } from '../../shared';
import { AdminService } from '../../shared/services/admin.service';
import { SharedAuthService } from '../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
@Component({
    selector: 'app-job-scheduling',
    templateUrl: './job-scheduling.component.html',
    styleUrls: ['./job-scheduling.component.scss'],
    standalone: false
})
export class JobSchedulingComponent implements OnInit {
  Activetab = 0;
  ActionNA = '-NA-';
  startDate = new Date(1990, 0, 1);
  selecteddate: any;
  fdisplayedColumns: string[] = ['jobName', 'Error', 'Params', 'refreshTime', 'Schedule', 'table_name', 'Action'];
  sdisplayedColumns: string[] = [
    'jobName',
    'table_row_count',
    'update_count',
    'Params',
    'refreshTime',
    'Schedule',
    'table_name',
    'Action'
  ];
  S_dataSource: MatTableDataSource<any>;
  F_dataSource: MatTableDataSource<any>;
  dateArray = [];
  selectedIndex = [];
  environment: string = 'steak-0';
  selectedOption = 'steak-0';
  dataSourceAdmin: MatTableDataSource<any>;
  displayedColumnsAdmin: string[] = [
    'User_Name',
    'Msid',
    'Justification',
    'Page',
    'Tab',
    'Request_Type',
    'Createdate',
    'Request_Status',
    'Action'
  ];
  showLoader: boolean = false;
  maxDate = new Date();
  data: any = [];
  mySelect = '1';
  selectedYear: any;
  selectedTable: any = '';
  reclassifyView: boolean = false;
  isAdmin: any = false;
  displayedColumnsMonthlyJobs: string[] = [
    'Environment',
    'Process_Level',
    'Process_Name',
    'Year',
    'Month',
    'Start_Time',
    'End_Time',
    'status'
  ];
  dataSourceMonthlyJobs: MatTableDataSource<any>;
  dataSourceErrorLogJobs: MatTableDataSource<any>;
  MonthlyJobsdata: any = [];
  errorData: any = [];
  lookupTables: any = [];
  hasUserRoleChangeAccess: boolean = false;
  endPointRefreshGetVar: any;
  endPointRefreshPostVar: any;
  updateUserRoleVar: any;
  updateUserErrorVar: any;
  updateTechopsAdminVar: any;
  msid: any;
  disableTrigger = false;
  currentRefreshDateTime: any;
  pageSize: any;
  showHoursMessage: boolean = false;
  userMsid: string;
  userRoles: any[] = [];
  secureGroups: any[] = [];
  selectedUserRoleType: string;
  selectedSecureGroupType: any[];
  hasReportAdminAccess: boolean = false;
  hasReportWfAccess: boolean = false;
  yearValues = [
    {
      id: 1,
      name: new Date().getFullYear() - 1
    },
    {
      id: 2,
      name: new Date().getFullYear() - 2
    },
    {
      id: 3,
      name: new Date().getFullYear() - 3
    },
    {
      id: 4,
      name: new Date().getFullYear() - 4
    }
  ];
  tableName = [
    {
      id: 1,
      name: '[dbo].[NEDD_Daily]'
    },
    {
      id: 2,
      name: '[dbo].[Capital_Demand_UCMG_Data_Daily]'
    },
    {
      id: 3,
      name: '[dbo].[App_CBA_Service_Daily]'
    },
    {
      id: 4,
      name: '[dbo].[TL_Technology_PADU]'
    },
    {
      id: 5,
      name: '[dbo].[TL_technology]'
    }
  ];
  public filterby: any = [
    { name: 'Technical Owner', value: 'techonwer' },
    { name: 'SLO Owner', value: 'sloonwer' },
    { name: 'Group', value: 'groupby' }
  ];

  hasAccess: any = false;
   // Controls visibility of Bulk Templates tab based on user permissions
  hasBulkTemplatesAccess: any = false;

  @ViewChild('paginatorMonthlyJobs') paginatorMonthlyJobs: MatPaginator;
  @ViewChild('paginatorAdmin') paginatorAdmin: MatPaginator;
  adminData: any = [];
  scount: any;
  fcount: any;
  constructor(
    private appViewService: AppViewService,
    public admnsrv: AdminService,
    public toaster: ToastrService,
    private cRef: ChangeDetectorRef,
    private readonly datePipe: DatePipe,
    private sharedAuthService: SharedAuthService // Inject DatePipe here
  ) {
    this.userMsid = this.sharedAuthService.getMsid();
    this.isAdmin = this.sharedAuthService.checkAdminSGAccess();
  }

  ngOnInit(): void {
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.getAccess();
      });
    } else {
       this.getAccess();
    }
    this.getUserRoles();
    this.getJobDetails();
    this.getMonthlyJobDetails();
    this.getAdminTable();
    this.getLookupTableName();
  }
  getUserRoles() {
    this.admnsrv.getUserRolesService(this.userMsid).subscribe(data => {
      this.userRoles = data['AllSecureRole']['Role'].split(',');
      this.secureGroups = data['AllSecureRole']['Secure_group_access'];
      if (this.secureGroups) this.secureGroups = data['AllSecureRole']['Secure_group_access'].split(',');
      this.selectedUserRoleType = data['userRole']?.['Role'] ? data['userRole']['Role'] : 'User';
      if (data['userRole']['Secure_group_access'])
        this.selectedSecureGroupType = data['userRole']['Secure_group_access'].split(',');
    });
  }
  updateUserRole() {
    let isDeleted;
    if (this.selectedUserRoleType == 'Admin') {
      isDeleted = '0';
    } else {
      isDeleted = '1';
    }
    const body = {
      IsDeleted: isDeleted,
      Secure_group_access: this.selectedSecureGroupType.join(','),
      Role: this.selectedUserRoleType,

    };
    this.admnsrv.updateUserRole(this.userMsid, this.selectedUserRoleType, body).subscribe(
      data => {
        this.updateUserRoleVar = data;
        this.toaster.success('Successfully updated User Role', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      },
      error => {
        this.updateUserErrorVar = error;
        this.toaster.error(`Something went wrong`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
      }
    );
  }
  secureGroupChange(event) {
    this.selectedSecureGroupType = event.value;
  }
  getLookupTableName() {
    this.lookupTables = [
      { name: 'Work Queue Master Table', id: 'WQ_MSTR' },
      { name: 'App Attribute Table', id: 'APP_ATTR' },
      { name: 'Lookup Table with no Hierarchy', id: 'LOOKUP_NO_HRY' },
      { name: 'Lookup Table with 1 Hierarchy', id: 'LOOKUP_WITH_HRY' },
      { name: 'UI Dynamic Content Table', id: 'UI_DYNAMIC_CONTENT_TABLE' },
      { name: 'Video Library Table', id: 'VIDEO_LIBRARY_TABLE' }
    ];
  }

  getAccess() {
      this.isAdmin = this.sharedAuthService.checkAdminSGAccess();
      this.hasAccess = this.sharedAuthService.getTohPageAccessDetails('admin-dashboard','edit');
      this.hasUserRoleChangeAccess =this.sharedAuthService.getTohPageAccessDetails('user_role_change','edit');
      this.hasReportAdminAccess = this.sharedAuthService.getTohPageAccessDetails('report_admin','edit');
      this.hasReportWfAccess = this.sharedAuthService.getTohPageAccessDetails('report_wf_edit','edit');
      this.hasBulkTemplatesAccess = this.sharedAuthService.getTohPageAccessDetails('bulk_template_generate','edit');
  }

  getDropDownText(id, object) {
    const selObj = _.filter(object, function(o) {
      return _.includes(id, o.id);
    });
    return selObj;
  }
  getJobDetails() {
    this.admnsrv.getJobDetls().subscribe((data: any) => {
      this.data = data;
      for (let idx = 0; idx < this.data.length; idx++) {
        this.data[idx]['Params'] = this.data[idx]['Params'].toLowerCase().split(',');
        if (
          this.data[idx]['Params'].includes('date') ||
          this.data[idx]['Params'].includes('year') ||
          this.data[idx]['Params'].includes('tablename')
        ) {
          this.disableTrigger = true;
        } else {
          this.disableTrigger = false;
        }
      }
      this.S_dataSource = new MatTableDataSource(this.data.success);
      this.scount = this.data.success.length;
      this.F_dataSource = new MatTableDataSource(this.data.failed);
      this.fcount = this.data.failed.length;
    });
  }

  getMonthlyJobDetails() {
    this.admnsrv.getMonthlyJobDetls().subscribe((jobs: any) => {
      this.MonthlyJobsdata = jobs;
      this.dataSourceMonthlyJobs = new MatTableDataSource(this.MonthlyJobsdata);
      this.dataSourceMonthlyJobs.paginator = this.paginatorMonthlyJobs;
    });
  }

  showJobLoader = false;
  submit(app, index, $event) {
    $event.stopPropagation();
    this.cRef.detectChanges();
    const obj = {
      createdById: this.sharedAuthService.getMsid(),
      createdByName: JSON.parse(sessionStorage.getItem('currentUser')) || sessionStorage.getItem('currentUser')
    };
    if (app.type == 'AIDE_REFRESH') {
      obj['refreshDate'] = this.updatedate(this.dateArray['AIDE_REFRESH']);
    }
    if (app.type == 'TechLandscape_Refresh') {
      obj['selectFields'] = {
        SelectFields:
          'product_id,name,description,oss,logo,market,homepage_url,organization,collaboration_url,additional_info_url,repo_url,jurisdiction,dataviability,alias,license,landscape,environment,padu'
      };
    }
    if (app.type == 'EP-Delta-refresh') {
      obj['refreshDate'] = this.updatedate(this.dateArray['EP-Delta-refresh']);
    }
    if (app.type == 'NDD-refresh') {
      obj['year'] = this.dateArray['NDD-refresh'];
    }
    if (app.type == 'Importer_Refresh') {
      obj['table'] = this.selectedTable;
    }
    this.handleEndPointRefresh(obj, index, false);
  }
  submit_error(app, index, $event) {
    $event.stopPropagation();
    this.cRef.detectChanges();
    const obj = {
      createdById: this.sharedAuthService.getMsid(),
      createdByName: JSON.parse(sessionStorage.getItem('currentUser')) || sessionStorage.getItem('currentUser')
    };
    if (app.type == 'AIDE_REFRESH') {
      obj['refreshDate'] = this.updatedate(this.dateArray['AIDE_REFRESH']);
    }
    if (app.type == 'TechLandscape_Refresh') {
      obj['selectFields'] = {
        SelectFields:
          'product_id,name,description,oss,logo,market,homepage_url,organization,collaboration_url,additional_info_url,repo_url,jurisdiction,dataviability,alias,license,landscape,environment,padu'
      };
    }
    if (app.type == 'EP-Delta-refresh') {
      obj['refreshDate'] = this.updatedate(this.dateArray['EP-Delta-refresh']);
    }
    if (app.type == 'NDD-refresh') {
      obj['year'] = new Date(this.dateArray['NDD-refresh']).toISOString();
    }
    if (app.type == 'Importer_Refresh') {
      obj['table'] = this.selectedTable;
    }
    this.handleEndPointRefresh(obj, index, true);
  }
  checkParamType(app, param) {
    if (app) {
      if (app['Params']?.includes(param)) {
        return true;
      } else {
        return false;
      }
    }
  }
  stopjobLoader() {
    this.showJobLoader = false;
    this.cRef.detectChanges();
  }
  selectChange(app,index) {
    this.selectedIndex.push(index);
    this.dateArray[app.type] = this.yearValues[index]['name'];
    this.disableTrigger = false;
  }
  tableNameChange(index) {
    this.selectedIndex.push(index);
    this.disableTrigger = false;
  }

  private handleEndPointRefresh(body: any, index: number, isError: boolean): void {
    const dataSource = isError ? this.F_dataSource : this.S_dataSource;
    const url = dataSource.data[index]['Endpoint'];
    const method = dataSource.data[index]['API_Method'].toLowerCase();
    this.disableTrigger = true;
    const request =
      method === 'get' ? this.admnsrv.endPointRefreshGet(url, body) : this.admnsrv.endPointRefreshPost(url, body);
    request.subscribe(
      () => {
        this.getJobDetails();
        this.disableTrigger = false;
        this.toaster.success(`Successfully updated on ${this.maxDate}`, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      },
      error => {
        this.getJobDetails();
        this.toaster.error(`Something went wrong`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
        console.log(error);
      }
    );
  }
  addDateEvent(event: MatDatepickerInputEvent<Date>, app, index) {
    this.selectedIndex.push(index);
    this.dateArray[app.type] = event.value;
    if (app.type == 'EP-Delta-refresh') {
      const diffInMs = Date.parse(new Date().toISOString()) - Date.parse(this.dateArray['EP-Delta-refresh']);
      const diffInHours = diffInMs / 1000 / 60 / 60;
      if (diffInHours > 72) {
        this.showHoursMessage = true;
        this.disableTrigger = true;
      } else {
        this.showHoursMessage = false;
        this.disableTrigger = false;
      }
    } else this.disableTrigger = false;
  }
  updatedate(date) {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  getAdminTable() {
    this.appViewService.getTechopsDevAdminPage().subscribe(res => {
      this.adminData = res;
      this.dataSourceAdmin = new MatTableDataSource(this.adminData);
      this.dataSourceAdmin.paginator = this.paginatorAdmin;
    });
  }

  status(value, app) {
    const data = {
      Request_Status: value,
      Updatedate: new Date(),
      page: app.Page
    };

    this.appViewService.updateTechopsAdminTable(data, app.Msid, app.Request_Type).subscribe(res => {
      if (value === 'Approved') {
        this.updateTechopsAdminVar = res;
        this.msid = this.sharedAuthService.getMsid();
      }
      this.getAdminTable();
    });
  }

  MonthlyJobFilter(filterName: string) {
    this.dataSourceMonthlyJobs.filter = filterName.trim().toLowerCase();
  }
  breakWord(value) {
    return value?.split(',')?.join(', ');
  }
}
